/**
 * The Emails area's reads (owner 2026-10-16, spec 2026-10-16-emails-marketing F28): ordinary catalog GETs;
 * every write is the named exception in `email-writes.ts`. Split out of `catalog.ts` on file-size grounds
 * only.
 *
 * Part 1: the brand and its saved versions, the contact list and one contact, the segments, their field
 * registry and one segment. `refresh` (a POST) is the static word beside a contact's address and
 * `fields`/`run` beside a segment id, all mirrored in `upstream-siblings.ts` so none can ride the param;
 * a segment id is also constrained to a plain token. `brand/versions` is static.
 *
 * Part 2: the marketing templates and one template (with its versions), the campaigns and one campaign
 * with its review, stats and recipients, and the sending limits. Nothing static sits beside a template
 * or campaign id upstream (every write is BELOW the id), recorded as empty sibling surveys.
 */
import type { ReadRoute } from "./catalog";

const PAGINATION = ["page", "pageSize"] as const;
const TOKEN = "{[A-Za-z0-9_]+}";

export const EMAIL_READ_ROUTES: readonly ReadRoute[] = [
  // One logged email, rebuilt upstream from what its row stored, for the
  // transactional log's row click. A static segment with the id in the query,
  // like `preview`, so `/notifications` keeps having no `:param` under it.
  { path: "/api/admin/notifications/sent-email", query: ["id"] },
  { path: "/api/admin/email/brand", query: [] },
  { path: "/api/admin/email/brand/versions", query: [] },
  { path: "/api/admin/email/settings", query: [] },
  {
    path: "/api/admin/email/contacts",
    query: [...PAGINATION, "kind", "status", "q"],
  },
  { path: "/api/admin/email/contacts/:email", query: [] },
  { path: "/api/admin/email/segments", query: ["status"] },
  { path: "/api/admin/email/segments/fields", query: [] },
  { path: `/api/admin/email/segments/:id${TOKEN}`, query: [] },
  { path: "/api/admin/email/templates", query: ["status"] },
  { path: `/api/admin/email/templates/:templateId${TOKEN}`, query: [] },
  { path: "/api/admin/email/campaigns", query: ["status", "q"] },
  { path: `/api/admin/email/campaigns/:campaignId${TOKEN}`, query: [] },
  { path: `/api/admin/email/campaigns/:campaignId${TOKEN}/review`, query: [] },
  { path: `/api/admin/email/campaigns/:campaignId${TOKEN}/stats`, query: [] },
  {
    path: `/api/admin/email/campaigns/:campaignId${TOKEN}/recipients`,
    query: [...PAGINATION, "status"],
  },
];
